import React, { useRef, useState } from "react";
import { Menu } from "lucide-react";
import { Logo } from "./Logo";
import { MobileNavigation } from "./MobileNavigation";

export default function MobileTopBar() {
    const [open, setOpen] = useState(false);
    const triggerRef = useRef(null);
    return (
        <header
            className="portal-mobile-topbar md:hidden sticky top-0 z-40 flex items-center justify-between px-5 border-b border-zinc-800/80 bg-[#0a0a0a]/95 backdrop-blur-xl"
            data-testid="mobile-topbar"
        >
            <Logo size={32} withSubtitle testid="mobile-brand-logo" />
            <button
                ref={triggerRef}
                type="button"
                onClick={() => setOpen(true)}
                data-testid="mobile-menu-button"
                className="h-11 w-11 inline-flex items-center justify-center rounded-md border border-zinc-800 text-zinc-300 hover:text-zinc-100 hover:bg-zinc-900/60 transition-colors"
                aria-label="Open navigation menu"
                aria-expanded={open}
                aria-haspopup="dialog"
            >
                <Menu className="h-5 w-5 stroke-[1.75]" />
            </button>
            <MobileNavigation open={open} onOpenChange={setOpen} triggerRef={triggerRef} />
        </header>
    );
}
